import Vue from 'vue';
import dialogComponent from '../components/Dialog.vue';

let app;
let container;
let appDom;
createContainer();

function createAppDom() {
    if (appDom) {
        removeAppDom();
    }
    appDom = document.createElement('div');
    appDom.id = `dialog_${+new Date()}`;
    container.appendChild(appDom);
}

function createContainer() {
    container = document.createElement('div');
    document.body.appendChild(container);
}

function dialog(config) {
    createAppDom();
    dialog.app = new Vue({
        render: (h) => h(dialogComponent, {
            props: config
        }),
    }).$mount(`#${appDom.id}`);
    return app;
}

function removeAppDom() {
    if (container.childNodes.length > 0) {
        Object.keys(container.childNodes).forEach(key => {
            container.removeChild(container.childNodes[key]);
        });
    }
}

dialog.remove = removeAppDom;
dialog.app = app;

export default dialog;
